document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-header-search-form]');
  if (!forms.length || !window.routes?.predictive_search_url) return;

  const debounce = (fn, wait = 250) => {
    let timeoutId;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn(...args), wait);
    };
  };

  forms.forEach((form) => {
    const input = form.querySelector('[data-header-search-input]');
    const dropdown = form.querySelector('[data-header-search-suggestions]');
    if (!input || !dropdown) return;

    let currentAbortController = null;

    const closeSuggestions = () => {
      dropdown.innerHTML = '';
      dropdown.classList.add('dn');
    };

    const renderSuggestions = (products) => {
      if (!products.length) {
        closeSuggestions();
        return;
      }

      const list = products
        .map((product) => {
          const title = product.title || '';
          const url = product.url || '#';
          return `<a class="header-search-suggestion-item" href="${url}">${title}</a>`;
        })
        .join('');

      dropdown.innerHTML = list;
      dropdown.classList.remove('dn');
    };

    const fetchSuggestions = debounce(async () => {
      const query = input.value.trim();
      if (query.length < 2) {
        closeSuggestions();
        return;
      }

      if (currentAbortController) {
        currentAbortController.abort();
      }
      currentAbortController = new AbortController();

      const params = new URLSearchParams({
        q: query,
        section_id: 'predictive-search',
        'resources[type]': 'product',
        'resources[options][prefix]': 'last',
        'resources[options][unavailable_products]': 'show',
        'resources[options][fields]': 'title,product_type,variants.title,vendor',
        'resources[limit]': '6',
      });

      try {
        const response = await fetch(`${window.routes.predictive_search_url}?${params.toString()}`, {
          signal: currentAbortController.signal,
        });
        if (!response.ok) {
          closeSuggestions();
          return;
        }

        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const productNodes = parsed.querySelectorAll('#predictive-search-results-products-list li a');

        const products = Array.from(productNodes)
          .slice(0, 6)
          .map((node) => ({
            title: node.querySelector('.predictive-search__item-heading')?.textContent?.trim() || node.textContent.trim(),
            url: node.getAttribute('href'),
          }))
          .filter((item) => item.title && item.url);

        renderSuggestions(products);
      } catch (error) {
        if (error?.name !== 'AbortError') closeSuggestions();
      }
    }, 220);

    input.addEventListener('input', fetchSuggestions);
    input.addEventListener('focus', fetchSuggestions);

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSuggestions();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeSuggestions();
    });
  });
});
